import { Supplier } from "./types";
import { Form, FormOptions } from "../PageBase";
import { generateName, getFormFields } from "../utils";
import { FormField } from "../../../../actions/Tenants/config/constantsTyped";

interface SupplierFormObject extends Omit<Supplier, "name" | "infos" | "fruit_types"> {
    fruit_type: string[];
    name?: string; // For display purposes in update forms
}

export const defineSupplierFormCreate = (onSaveSupplier: (supplier: Supplier) => void, onDeleteSupplier: (id: string) => void) => (formOptions: FormOptions | undefined, entity: Partial<Supplier> | undefined) => {
    const baseForm = getFormFields(formOptions, "Supplier");

    const nameField: FormField = {
        label: "Identifier",
        name: "name",
        type: "text",
    };

    const supplierForm: FormField[] = entity?.id
        ? [nameField, ...baseForm]
        : baseForm;

    const onSave = (formObject: SupplierFormObject, entity: Partial<Supplier>) => {
        const nameParts = [formObject.label, formObject.country].filter(Boolean);
        const supplier: any = {
            ...entity,
            ...formObject,
            fruit_types: formObject.fruit_type,
            fruit_type: undefined,
            name: formObject.name || generateName(nameParts.join(" ")),
            infos: [...(entity.infos ?? [])]
        };

        onSaveSupplier(supplier as Supplier);
    };

    const onDelete = (_: SupplierFormObject, entity: Partial<Supplier>) => {
        onDeleteSupplier(entity.id!);
    };

    const getFormObjectFromEntity = (entity: Partial<Supplier>): Partial<SupplierFormObject> => {
        return {
            ...entity,
            fruit_type: entity.fruit_types || [],
            name: entity.name,
        };
    };

    const supplierModal: Form<SupplierFormObject, Supplier> = {
        title: "Supplier",
        fields: supplierForm,
        modalButtonLabel: "Edit",
        onSave,
        onDelete,
        getFormObjectFromEntity
    };

    return supplierModal;
};
